var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 42,
    viewBox: "0 0 343 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_724_133)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.31 19.6081L296.476 33.4667H308.462L315.076 25.8979L321.705 33.4667H333.692L320.843 19.6081L331.482 7.88625H319.692L315.076 13.1829L310.46 7.88625H298.882L309.31 19.6081Z",
    fill: "#051343"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.2 14.9284C288.908 14.9284 291.073 17.5767 291.073 20.7066C291.073 23.8364 288.923 26.4396 285.2 26.4396C281.477 26.4396 279.328 23.9417 279.328 20.7066C279.328 17.4714 281.477 14.9284 285.2 14.9284ZM285.2 7.0436C276.921 7.0436 269.702 11.9791 269.702 20.7066C269.702 29.434 276.982 34.3244 285.2 34.3244C293.418 34.3244 300.698 29.3889 300.698 20.7066C300.698 12.0243 293.479 7.0436 285.2 7.0436Z",
    fill: "white",
    stroke: "#051343",
    strokeWidth: 1.5,
    strokeMiterlimit: 2.61
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.983 6.83295H249.679C252.343 6.83295 255.4 7.01351 255.4 10.0531C255.4 12.882 252.691 13.2732 250.087 13.2732H248.983V6.83295ZM254.295 33.4667C261.212 33.4667 267.992 31.1795 267.992 24.1976C267.992 19.563 265.691 16.3429 260.273 15.7259V15.6356C263.33 14.2663 264.435 11.8437 264.435 8.84929C264.435 2.49932 259.925 0.197075 253.205 0.197075H239.16V33.4517H254.31L254.295 33.4667ZM248.983 19.7135H249.981C253.19 19.7135 258.063 19.3222 258.063 23.3248C258.063 26.9813 253.145 26.8609 250.239 26.8609H248.983V19.7135Z",
    fill: "#051343"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.685 7.88626H207.559V33.4667H216.685V23.1442C216.685 18.7504 217.941 15.4099 223.011 15.4099C224.419 15.4099 225.614 15.5604 226.871 16.2526V7.52512H225.115C221.558 7.52512 218.547 8.92452 216.791 12.0694H216.685V7.88626Z",
    fill: "#051343"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.121 21.2483C206.121 12.5208 200.96 7.0436 192.03 7.0436C183.661 7.0436 177.789 12.1747 177.789 20.7066C177.789 29.2384 184.16 34.3244 192.681 34.3244C195.648 34.3244 198.553 33.6322 200.899 32.1877C203.26 30.7431 205.061 28.5462 205.758 25.5518H196.979C195.981 27.2522 194.573 27.8992 192.621 27.8992C188.852 27.8992 186.9 25.8979 186.9 22.2113H206.106V21.2633L206.121 21.2483ZM187.066 16.9598C187.611 14.3115 189.821 12.9271 192.484 12.9271C194.936 12.9271 197.206 14.5221 197.645 16.9598H187.066Z",
    fill: "#051343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.396 0.21212H167.27V33.4667H176.396V0.21212Z",
    fill: "#051343"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.221 9.31575V33.4667H165.348V9.31575C164.228 10.5797 162.593 11.3772 160.777 11.3772C158.961 11.3772 157.341 10.5797 156.206 9.31575H156.221Z",
    fill: "#051343"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.239 7.88625H145.112V10.3841C143.205 8.14206 140.103 7.0436 137.136 7.0436C129.508 7.0436 124.242 13.3334 124.242 20.6614C124.242 27.9895 129.614 34.3244 137.227 34.3244C140.239 34.3244 143.402 33.1808 145.007 30.6378H145.112V33.4818H154.239V7.88625ZM139.543 14.9284C143.251 14.9284 145.415 17.5767 145.415 20.7066C145.415 23.8364 143.251 26.4396 139.543 26.4396C135.835 26.4396 133.671 23.9417 133.671 20.7066C133.671 17.4714 135.835 14.9284 139.543 14.9284Z",
    fill: "#051343"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.6165 33.4667H96.3935V11.8287H96.4995L101.918 33.4667H105.823L111.998 11.8287H112.103L112.043 33.4667H121.881V0.21212H107.109L103.976 15.9667L100.192 0.21212H86.6165V33.4667Z",
    fill: "#051343"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3584 21.2483C73.3584 12.5208 68.1974 7.0436 59.2679 7.0436C50.8983 7.0436 45.026 12.1747 45.026 20.7066C45.026 29.2384 51.3978 34.3244 59.9187 34.3244C62.8851 34.3244 65.791 33.6322 68.1369 32.1877C70.4979 30.7431 72.2989 28.5462 72.9951 25.5518H64.217C63.2181 27.2522 61.8105 27.8992 59.8581 27.8992C56.0896 27.8992 54.1372 25.8979 54.1372 22.2113H73.3432V21.2633L73.3584 21.2483ZM54.2885 16.9598C54.8334 14.3115 57.0431 12.9271 59.7068 12.9271C62.1586 12.9271 64.4288 14.5221 64.8678 16.9598H54.2885Z",
    fill: "#051343"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4969 0.21212V33.4667H25.6232V20.3454C25.6232 17.351 26.7735 14.2663 30.3907 14.2663C34.0079 14.2663 34.5073 17.351 34.5073 20.3454V33.4667H43.6336V17.8024C43.6336 11.317 40.4705 7.02856 33.9474 7.02856C30.3907 7.02856 27.8329 8.32263 25.7292 11.1214H25.6232V0.21212H16.4969Z",
    fill: "#051343"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.77708 15.3648H14.9532V7.88626H9.77708V0.21212H0.650795V3.05606V7.88626V15.3648V25.3562V33.4667H9.77708V15.3648Z",
    fill: "#051343"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.777 0.21212C157.962 0.21212 155.661 2.49931 155.661 5.29812C155.661 8.09692 157.962 10.3841 160.777 10.3841C163.592 10.3841 165.893 8.09692 165.893 5.29812C165.893 2.49931 163.592 0.21212 160.777 0.21212Z",
    fill: "#EB008B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.303 34.3696C280.978 40.554 288.257 40.5239 296.097 34.3696C288.5 38.2217 281.22 38.4173 274.303 34.3696Z",
    fill: "#EB008B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.337 26.2139C337.34 26.2139 335.69 27.8541 335.69 29.8403C335.69 31.8265 337.34 33.4667 339.337 33.4667C341.335 33.4667 342.985 31.8265 342.985 29.8403C342.985 27.8541 341.335 26.2139 339.337 26.2139Z",
    fill: "#051343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6784 39.4254H1.18051C0.528534 39.4254 0 39.9509 0 40.5991C0 41.2473 0.528534 41.7728 1.18051 41.7728H71.6784C72.3304 41.7728 72.8589 41.2473 72.8589 40.5991C72.8589 39.9509 72.3304 39.4254 71.6784 39.4254Z",
    fill: "#EB008B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_724_133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 41.5758,
    fill: "white",
    transform: "translate(0 0.21212)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9274bbdaad68fc3ea2ef3cc5af2d2a8a.svg";
export { ForwardRef as ReactComponent };